import qs from "qs";

export type EmailParams = {
  body?: string;
  subject?: string;
  separator?: string;
};

interface EmailButtonProps {
  params: EmailParams;
  className?: string;
  children: React.ReactNode;
}

export const EmailButton = ({
  params,
  className,
  children,
}: EmailButtonProps) => {
  const handleClick = () => {
    window.location.href = `mailto:?${qs.stringify(params)}`;
  };

  return (
    <button
      type="button"
      aria-label="Email"
      onClick={handleClick}
      className={className}
      css={`
        text-align: left;
        color: inherit;
        background-color: transparent;
        border: none;
      `}
    >
      {children}
    </button>
  );
};
